<script>
import rocket from "../rocket/index.vue";
import rocketsvg from "../rocketsvg/index.vue";
import { mapState } from "vuex";
// import { db } from "../../plugins/firebaseDatabase";
// import { ref, onValue } from "firebase/database";

export default {
  name: "app",
  components: {
    rocket,
    rocketsvg,
  },
  data() {
    return {
      latitude: "",
      longitude: "",
      geoId: null,
      rocketsvgswitch: false,
      showswich: true,
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState({
      rockettime: (state) => state.space.rockettime,
    }),
  },
  created() {
    this.$store.dispatch("space/resetState");
  },
  mounted() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    this.$store.dispatch("space/updateRockettime", {
      rockettime: 0,
    });
    this.rocketsvgswitch = false;
    this.showswich = true;
    if (navigator.geolocation) {
      this.geoId = navigator.geolocation.watchPosition(
        this.successGPS,
        this.errorGPS,
        {
          enableHighAccuracy: true,
          maximumAge: 25000,
          timeout: 5000,
        }
      );
    } else {
      window.alert("您的裝置不具備GPS，無法使用此功能");
    }
  },
  beforeDestroy() {
    navigator.geolocation.clearWatch(this.geoId);
    clearInterval(this.clock);
  },
  methods: {
    successGPS(position) {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;
      let obj = {
        latitude: lat,
        longitude: lng,
      };
      this.$store.dispatch("space/updateGeo", obj);
    },
    errorGPS() {
      navigator.geolocation.clearWatch(this.geoId);
    },
    getDateb(date) {
      let dateb;
      if (typeof date === "string") {
        dateb = date.match(
          new RegExp(
            "(\\d{4})-(\\d{2})-?(\\d{2})?\u0020?(\\d{2})?:?(\\d{2})?:?(\\d{2})?",
            "g"
          )
        );
        dateb = dateb ? dateb.join("").split("-").join("/") : "";
        date = date.split("-").join("/");
      }
      return dateb || date;
    },
    formatDate(date, sp) {
      let enddate = this.getDateb(date);
      let spStr = sp || ".";
      let dateYear = new Date(enddate).getFullYear();
      let dateMonth = (new Date(enddate).getMonth() + 1)
        .toString()
        .padStart(2, "0");
      let dateDate = new Date(enddate).getDate().toString().padStart(2, "0");
      return `${dateYear}${spStr}${dateMonth}${spStr}${dateDate}`;
    },
  },
};
</script>

<!-- 引入template.html,style.scss  -->
<template src="./template.html"></template>
<style lang="scss" src="./style.scss"></style>
